"use client";
import {Flex} from "@aws-amplify/ui-react";

export const metadata = {
    title: "Loading",
    description: "Loading page for issues",
}; 


export default function LoadingComponent() {
    return (
        <>
            <Flex
                width="100%"
                height="100vh"
                direction="row"
                justifyContent="center"
                alignItems="center"
                alignContent="center"
                wrap="nowrap"
                gap="1rem"
            >
                <div className="sync-loader" aria-label="Loading Spinner" data-testid="loader" role="status">
                    <span className="dot dot-1" />
                    <span className="dot dot-2" />
                    <span className="dot dot-3" />
                </div>
            </Flex>

            <style jsx>{`
                .sync-loader {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                }

                .dot {
                    width: 20px;
                    height: 20px;
                    border-radius: 9999px;
                    position: relative;
                    color: var(--dot-color);
                    transform-origin: center bottom;
                    will-change: transform, opacity, box-shadow;
                    animation: sync-bounce 1s cubic-bezier(0.28, 0.84, 0.42, 1) infinite;
                    animation-delay: var(--delay);
                }

                .dot::after {
                    content: "";
                    position: absolute;
                    inset: -7px;
                    border-radius: 9999px;
                    border: 2px solid currentColor;
                    opacity: 0;
                    transform: scale(0.7);
                    animation: sync-chat-wave 1s ease-out infinite;
                    animation-delay: var(--delay);
                }

                .dot-1 {
                    --dot-color: #427FF7;
                    --delay: -0.25s;
                    background-color: var(--dot-color);
                }

                .dot-2 {
                    --dot-color: #6D66FF;
                    --delay: -0.125s;
                    background-color: var(--dot-color);
                }

                .dot-3 {
                    --dot-color: #FF4A3B;
                    --delay: 0s;
                    background-color: var(--dot-color);
                }

                @keyframes sync-bounce {
                    0%,
                    100% {
                        transform: translateY(0) scaleX(1) scaleY(1);
                        opacity: 0.82;
                        box-shadow: 0 0 0 rgba(0, 0, 0, 0);
                    }
                    18% {
                        transform: translateY(5px) scaleX(1.16) scaleY(0.84);
                        opacity: 0.9;
                    }
                    38% {
                        transform: translateY(-18px) scaleX(0.88) scaleY(1.12);
                        opacity: 1;
                        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.18);
                    }
                    52% {
                        transform: translateY(-10px) scaleX(0.94) scaleY(1.06);
                        opacity: 0.98;
                    }
                    68% {
                        transform: translateY(-2px) scaleX(1.02) scaleY(0.98);
                        opacity: 0.95;
                    }
                    82% {
                        transform: translateY(0) scaleX(1.05) scaleY(0.96);
                        opacity: 0.88;
                    }
                }

                @keyframes sync-chat-wave {
                    0%,
                    24%,
                    100% {
                        opacity: 0;
                        transform: scale(0.7);
                    }
                    38% {
                        opacity: 0.45;
                        transform: scale(1);
                    }
                    55% {
                        opacity: 0;
                        transform: scale(1.35);
                    }
                }
            `}</style>
        </>
    );
}